export default __webpack_public_path__ + "static/media/Pfont-Regular.e65d7b1b.ttf";